export default class MenuModal {
    constructor($el) {
        this.$el = $el;
        this.type = this.$el.dataset.menuModal;
        this.$root = this.$el.closest('[data-website-switcher]') || document;
        this.$headerMenu = this.$el.closest('[data-header-menu]');
        this.$trigger = this.$root.querySelector(`[data-menu-modal-trigger='${this.type}']`);
        this.$triggerIcon = this.$trigger ? this.$trigger.querySelector('[data-menu-modal-icon]') : null;

        this.closeTimeout = null;

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.positionArrow = this.positionArrow.bind(this);

        if (!this.$trigger) {
            return;
        }

        this.$trigger.addEventListener('mouseenter', this.openModal);
        this.$trigger.addEventListener('mouseleave', this.closeModal);
        //this.$trigger.addEventListener('click', this.toggleModal);

        this.$el.addEventListener('mouseenter', this.openModal);
        this.$el.addEventListener('mouseleave', this.closeModal);

        document.addEventListener('click', this.handleDocumentClick);
        window.addEventListener('resize', this.positionArrow);
    }

    openModal() {
        clearTimeout(this.closeTimeout);
        this.positionArrow();
        this.$el.classList.add('menu-modal--open');
        this.$trigger.setAttribute('aria-expanded', 'true');

        if (this.$headerMenu) {
            this.$headerMenu.classList.add('header__menu--submenu-open');
        }

        if (this.$triggerIcon) {
            this.$triggerIcon.classList.add('website-switcher__icon--active');
        }
    }

    positionArrow() {
        const triggerRect = this.$trigger.getBoundingClientRect();
        const modalRect = this.$el.getBoundingClientRect();
        const arrowLeft = triggerRect.left + (triggerRect.width / 2) - modalRect.left;

        this.$el.style.setProperty('--menu-modal-arrow-left', `${arrowLeft}px`);
    }

    closeModal() {
        this.closeTimeout = setTimeout(() => {
            this.$el.classList.remove('menu-modal--open');
            this.$trigger.setAttribute('aria-expanded', 'false');

            if (this.$headerMenu) {
                this.$headerMenu.classList.remove('header__menu--submenu-open');
            }

            if (this.$triggerIcon) {
                this.$triggerIcon.classList.remove('website-switcher__icon--active');
            }
        }, 100);
    }

    toggleModal(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.$el.classList.contains('menu-modal--open')) {
            this.closeModal();
            return;
        }

        this.openModal();
    }

    handleDocumentClick(e) {
        if (this.$root.contains(e.target) || this.$el.contains(e.target)) {
            return;
        }

        this.closeModal();
    }
}
